export function formatPercentage(value: string | number): string {
	const num = typeof value === 'number' ? value : parseFloat(value);

	if (isNaN(num)) {return '';}

	const hasDecimals =
		typeof value === 'string' && value.includes('.') && !value.endsWith('.00');

	if (!hasDecimals || num % 1 === 0) {
		return `${num.toFixed(0)} %`;
	}

	return `${num.toFixed(2).replace('.', ',')} %`;
}

/** 
	Cette fonction permet d'ajouter un séparateur tous les x caractères.
	Exemple : 337668552 => 337 668 552
*/
export const formatByInterval = (str: string, interval: number, fromRight = false, separator = ' '): string => {
	const cleaned = str.replace(/\s+/g, '');

	if (interval <= 0){ 
		return cleaned;
	}

	if (fromRight) {
		const reversed = cleaned.split('').reverse().join('');
		const matches = reversed.match(new RegExp(`.{1,${interval}}`, 'g'));

		if (!matches){ 
			return cleaned;
		}

		return matches
			.map(segment => segment.split('').reverse().join(''))
			.reverse()
			.join(separator);
	} else {
		const matches = cleaned.match(new RegExp(`.{1,${interval}}`, 'g'));
		return matches ? matches.join(separator) : cleaned;
	}
};

export const hasSpaces = (string: string) => {
	return /\s/.test(string);
};

/** 
	Cette fonction retourne une chaîne de caractère sans aucun espace.
*/
export const removeSpacesIfAny = (string: string) => {
	if (hasSpaces(string)) {
		return string.replace(/\s+/g, '');
	}
	return string;
};

export const truncate = (string: string, length: number) => {
	if (length < string.length){
		return string.substring(0, length) + '...';
	} else {
		return string;
	}
};